import {
  CaseType,
  ParsedEventsType,
  ReportEventType,
  ReportType,
} from 'src/graphql';
import { removeDuplicateNamedOffenders } from '../removeDuplicateNamedOffenders';
import { removeLinkedExternalNamedOffenders } from '../removeLinkedExternalNamedOffenders';
import {
  getCasePostsubmissionNamedOffenders,
  getEventPostsubmissionNamedOffenders,
  getReportPostsubmissionNamedOffenders,
} from './getPostsubmissionNamedOffenders';
import {
  getCasePresubmissionNamedOffenders,
  getEventPresubmissionNamedOffenders,
  getReportPresubmissionNamedOffenders,
} from './getPresubmissionNamedOffenders';

export const getCaseNamedOffenders = (
  caseInstance: CaseType,
  normalizeDataEnabled: boolean,
) => {
  const preSubmissionOffenders = getCasePresubmissionNamedOffenders(
    caseInstance,
    normalizeDataEnabled,
  );
  const postSubmissionOffenders =
    getCasePostsubmissionNamedOffenders(caseInstance);

  const namedOffendersWithoutLinkedOffenders =
    removeLinkedExternalNamedOffenders([
      ...preSubmissionOffenders,
      ...postSubmissionOffenders,
    ]);

  const uniqueNamedOffenders = removeDuplicateNamedOffenders(
    namedOffendersWithoutLinkedOffenders,
  );

  return uniqueNamedOffenders;
};

export const getReportNamedOffenders = (
  report: ReportType,
  useNormalizedData: boolean,
) => {
  const preSubmissionOffenders = getReportPresubmissionNamedOffenders(
    report,
    useNormalizedData,
  );
  const postSubmissionOffenders = getReportPostsubmissionNamedOffenders(report);

  const namedOffendersWithoutLinkedOffenders =
    removeLinkedExternalNamedOffenders([
      ...preSubmissionOffenders,
      ...postSubmissionOffenders,
    ]);

  const uniqueNamedOffenders = removeDuplicateNamedOffenders(
    namedOffendersWithoutLinkedOffenders,
  );

  return uniqueNamedOffenders;
};

export const getEventNamedOffenders = (
  parsedEvent: ParsedEventsType,
  report: ReportType,
  useNormalizedData: boolean,
  reportEvent?: ReportEventType,
) => {
  const preSubmissionOffenders = getEventPresubmissionNamedOffenders(
    parsedEvent,
    report,
    useNormalizedData,
    reportEvent,
  );
  const postSubmissionOffenders = reportEvent
    ? getEventPostsubmissionNamedOffenders(reportEvent)
    : [];

  const namedOffendersWithoutLinkedOffenders =
    removeLinkedExternalNamedOffenders([
      ...preSubmissionOffenders,
      ...postSubmissionOffenders,
    ]);

  const uniqueNamedOffenders = removeDuplicateNamedOffenders(
    namedOffendersWithoutLinkedOffenders,
  );

  const internalOffenderIds = uniqueNamedOffenders
    .filter((offender) => !offender.external)
    .map((offender) => Number(offender.id));

  return { namedOffenders: uniqueNamedOffenders, internalOffenderIds };
};
